import React, { useEffect } from 'react';
import { TPIService } from '../../../../base/tpiService';
//import { config } from './config';


const OneDriveStorage = () =>{

  const getURLFetch = async() => {
    const parts = window.location.hash.split("&");
    if (parts.length > 0) {
      let partsMap = await parts.map((i) => i.split("="));
      let accessToken = await partsMap.find((i) => i[0] === "#access_token");
      if (accessToken && Array.isArray(accessToken) && accessToken.length===2) {
        console.log("accessToken--->",Array.isArray(accessToken)?accessToken.length:[]);
        await TPIService.storeToken(accessToken[1].toString()).then(async()=>{
          const oneDrive  =  await TPIService.getClientsCloud('one-drive');
          console.log('oneDrive--->',oneDrive);
        });
       
   
      }
    }
  };
  useEffect(()=>{
    getURLFetch();
  },[]);
  

  

  return(<><h1>Successfully logged in to One drive</h1></>);
};


export default OneDriveStorage;